<template>
  <a-social-sharing
    hashtags="investingLive"
    twitter-user="investinglive"
    network="telegram"
    class="social-icon-border"
    :url="sharingUrl"
    :title="title"
    :description="description"
    :quote="title"
    :open-in-iframe="openInIframe"
  >
    <a-icon
      v-bind="$attrs"
      :width="16"
      :height="16"
      is-button
      tabindex="-1"
      :icon="$attrs.icon || ICON.TELEGRAM_PURPLE"
    />
  </a-social-sharing>
</template>

<script>
import socialSharing from '../socialSharing'

export default {
  name: 'Telegram',
  mixins: [socialSharing]
}
</script>
